import { render, staticRenderFns } from "./FormWhatsApp.vue?vue&type=template&id=e06b68ba&"
import script from "./FormWhatsApp.vue?vue&type=script&lang=js&"
export * from "./FormWhatsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports